import React from "react";
import { BUILD_INFO } from "../buildInfo";

const Footer = () => {
    const formattedDate = new Date(BUILD_INFO.buildDate).toLocaleString("es-CO", {
        dateStyle: "short",
        timeStyle: "medium",
    });

    return (
        <footer
            style={{
                textAlign: "center",
                padding: "0.6rem",
                fontSize: "0.72rem",
                color: "var(--text-muted, #6b6f82)",
                opacity: 0.75,
            }}
        >
            <span title={BUILD_INFO.message || undefined}>
                Admin Domicilios SURA · v{BUILD_INFO.version} · versión {BUILD_INFO.commit || "local"} · Desplegado: {formattedDate}
            </span>
        </footer>
    );
};

export default Footer;
